import { createSelector } from "@reduxjs/toolkit";
import _ from "lodash";
import { selectArticlegroupsMap } from "./selectArticlegroupsMap";

export const selectArticlegroupParentsMap = createSelector([selectArticlegroupsMap], (articlegroupsMap) => {
  const map: Record<string, Record<string, boolean>> = {};
  _.values(articlegroupsMap).forEach((articlegroup) => {
    if (articlegroup.parentId && articlegroupsMap[articlegroup.parentId] != null) {
      if (!map[articlegroup.id]) {
        map[articlegroup.id] = {};
      }
      map[articlegroup.id][articlegroup.parentId] = true;
    }

    if (articlegroup.category) {
      if (!map[articlegroup.id]) {
        map[articlegroup.id] = {};
      }
      map[articlegroup.id][articlegroup.category] = true;
    }
  });
  return _.chain(map)
    .mapValues((record) => {
      return _.keys(record);
    })
    .value();
});
